import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import imgLogo from './DPMS_Form_Logo.png';
import rightLogo from './right_bar.jpg';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import validator from "validator";

function PictureMarkingApprovalRequest() {
    const auth = useAuth();
    const [configJsonFile, setConfigJsonFile] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
                const data = await response.json();
                setConfigJsonFile(data);
                console.log("Json file read from the Public folder completed:");
            } catch (error) {
                console.error('Error fetching Config JSON file data:', error);
            }
        }
        fetchData();
    }, []);

    const navigate = useNavigate();
    const [apimessage, setAPIMessage] = useState('');
    const [modelPopupshow, setmodelPopupshow] = useState(false);
    const [selectedFile, setSelectedFile] = useState([]);

    // Vendor Information section fields
    const [VendorCode, setVendorCode] = useState("");
    const [VendorName, setVendorName] = useState("");
    const [DPMSTicketNumber, setDPMSTicketNumber] = useState("");
    const [VendorEmail, setVendorEmail] = useState("");
    const [DateValue, setDateValue] = useState(new Date().toISOString().split('T')[0]);
    const [SupplierComments1, setSupplierComments1] = useState("");
    const [InitiatorEmailAddress, setInitiatorEmailAddress] = useState("");

    const [initiatorEmailError, setInitiatorEmailError] = useState("");
    const [vendorEmailError, setVendorEmailError] = useState("");

    const [isChecked, setIsChecked] = useState(false);
    const [isConfirmChecked, setIsConfirmChecked] = useState(false);
    const csrfToken = useRef(null);
    const cookieToken = useRef(null);
    const [apiErrormessage, setApiErrormessage] = useState("");
    const [invalidTicketID, setInvalidTicketID] = useState("");
    const [invalidVendorCode, setInvalidVendorCode] = useState("");
    const [loading, setLoading] = useState(false);

    let storedValue = localStorage.getItem("DPMSProcessID");
    let autoIncrementVal = "";
    let newProcessIDNum = "";

    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
    }

    // Form submit 
    const handleSubmit = async (event) => {

        //Checking at least one general information row;
        if (validator.isEmail(VendorEmail)) {
            const isSubmitConfirm = window.confirm('Are you sure you want to submit this request?');
            if (isSubmitConfirm) {
                event.preventDefault();
                setLoading(true);
                var CurrentYear = getCurrentDateTime();
                if (storedValue == null) {
                    storedValue = 1;
                }

                // console.log("Auth User data Token: "+auth.userData.access_token);      
                var resTokenApiVal = auth.userData.access_token;
                // Call API Start
                newProcessIDNum = Number(storedValue) + 1;
                if (storedValue === 1) {
                    autoIncrementVal = String(storedValue).padStart(3, 0);
                }
                else {
                    autoIncrementVal = String(newProcessIDNum).padStart(3, 0);
                }
                const requestId = selectedFile.length;
                // Create JSON File
                var dictstring = {
                    ProcessInfo: {
                        domainId: "DPMSUpdateMarkingForm",
                        ProcessId: configJsonFile.PendingMarkApprovalProcessId,
                        NewRequest: false,
                        InstanceNumber: DPMSTicketNumber,
                        AttachmentID: "Att_" + configJsonFile.PendingMarkApprovalProcessId + "_" + CurrentYear + "_" + autoIncrementVal + "_" + requestId,
                        PathID: configJsonFile.PictureMarkingApprovalRequestPathID,
                        workflowID: configJsonFile.DPMSGuids.WorkflowGuid,
                        businessEntity: configJsonFile.DPMSGuids.BusinessEntityGuid,
                        dbId: configJsonFile.DPMSGuids.dbId,
                        formTypeId: configJsonFile.DPMSGuids.formTypeId,
                        BaseBPSPortalAddress: configJsonFile.BaseBPSPortalAddress,
                        WebconClientId: configJsonFile.WebconClientId,
                        WebconclientSecret: configJsonFile.WebconclientSecret,
                        WebconTokenURL: configJsonFile.WebconTokenURL
                    },
                    Form:
                        [
                            { GUID: configJsonFile.DPMSGuids.VendorCode, sValue: VendorCode + "#" + VendorCode, name: "Vendor Code" },
                            { GUID: configJsonFile.DPMSGuids.VendorEmail, sValue: VendorEmail, name: "Vendor Email" },
                            { GUID: configJsonFile.DPMSGuids.InitiatorEmailAddress, sValue: InitiatorEmailAddress, name: "InitiatorEmailAddress" },
                            { GUID: configJsonFile.DPMSGuids.SupplierComments, sValue: SupplierComments1, name: "Supplier Comments" }
                        ],
                    GeneralInformation: [],
                    GeneralInformationListGuids: {
                        PartNumberGuid: "",
                        ReasonForScrapGuid: "",
                        QuantityGuid: "",
                        PO_SA_NumberGuid: "",
                        QN_RFA_NumberGuid: "",
                        SerialNumberGuid: "",
                        generalInfoItemListGuid: ""
                    }
                };
                //alert(dictstring);
                console.log(dictstring);
                CallWebAPI(dictstring, resTokenApiVal);

                // Update Session variable to get increment num
                localStorage.setItem("DPMSProcessID", newProcessIDNum);
                // Call API End 
            }
        }
        else {
            alert("Please enter valid email address!");
            event.preventDefault();
        }
    }

    // Call API to upload files to S3
    const CallWebAPI = async (requestBody, getTokeVal) => {
        try {
            console.log("Attempting to Creation/Updation API...");
            const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_APIUrl);
            if (!isValidDomain(parsedUrl.hostname)) {
                throw new Error('Invalid domain');
            }
            const axiosInstance = axios.create({
                baseURL: configJsonFile.ServerAPIUrl,
                allowAbsoluteUrls: false
                });
            axios.post(parsedUrl, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-id': configJsonFile.ClientId,
                    'Authorization': "Bearer " + getTokeVal,
                    'RequestVerificationToken': csrfToken.current
                }
            }).then(res => {
                if (res.status === 201 || res.status === 200 || res.status === 202) {
                    var elementID = res.data;
                    if (selectedFile.length > 0) {
                        for (let i = 0; i < selectedFile.length; i++) {
                            // upload each file to S3 calling API here
                            let Num = i + 1;
                            CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
                        }
                    }else{
                        setLoading(false);
                        setmodelPopupshow(true);          
                        setApiErrormessage("");
                      }                    
                } else {
                    console.log("Status Code:" + res.status);
                    console.log("Status Data:" + res.data);
                }
            }).catch(error => {
                if (error.response) {
                    console.log('Error response:', error.response.data);
                    setLoading(false);
                    setApiErrormessage(error.response.data || 'An error occurred');                    
                    if (error.response.data.includes("Element does not exist") || error.response.data.includes("Access to the selected workflow instance is denied!")) {
                        setInvalidTicketID("Invalid");
                        setApiErrormessage("TicketID '" + DPMSTicketNumber + "' does not exist, Please enter correct value and submit again.")
                    } else {
                        setInvalidTicketID("");
                    };
                    if (error.response.data.includes('Vendor Code')) {
                        setInvalidVendorCode("Invalid");
                        setApiErrormessage("Vendor Code '" + VendorCode + "' does not exist, Please enter correct value and submit again.")
                    }
                    else if (error.response.data.includes("Path is not available in current step"))
                    {
                        setApiErrormessage("DPMS form# " + DPMSTicketNumber + " is not yet at 'Pending Step2 - Pictures Marking' Step, please wait for email notification to proceed.")
                    }                     
                    else {
                        setInvalidVendorCode("");
                    };
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }
            });
            console.log("... Attempt completed!");
        } catch (err) {
            console.log(err);
            console.log("Error Json:" + err.toJSON());
            setAPIMessage("Failed Due to:" + err);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

    }
    const CallWebAPIUploadFileToS3 = async (requestBody, num, getTokeVal, elementID) => {
        try {
            let fileNameVal = elementID + "_" + num + "-" + requestBody.name;
            console.log("FileName: " + fileNameVal);
            const formData = new FormData();
            formData.append('file', requestBody);
            formData.append('fileName', fileNameVal);
            formData.append('processID', "");
            formData.append('cookie', cookieToken.current);

            axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-api-id': configJsonFile.ClientId,
                    'Authorization': "Bearer " + getTokeVal
                }
            }).then(res => {
                if (res.status === 201 || res.status === 200 || res.status === 202) {
                    setLoading(false);
                    setmodelPopupshow(true);
                    setAPIMessage("Files are uploaded successfully to AWS S3");
                } else {
                    console.log("Status Code:" + res.status);
                }
            });

        } catch (err) {
            setLoading(false);
            setApiErrormessage(err.response.data || 'An error occurred');
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

    }

    const isValidDomain = (domain) => {
        const allowedDomains = ['apid.pwc.ca', 'apiq-ext.pwc.ca', 'api-ext.pwc.ca'];
        return allowedDomains.includes(domain);
    };
    const onClickHomeHandler = async (event) => {
        const isConfirmedHome = window.confirm('You might loose the data, Are you sure you want to go to home page?');
        if (isConfirmedHome) {
            navigate('/');
        }
    }
    const onClickCancelHandler = async (event) => {
        const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
        if (isConfirmedCancel) {
            navigate('/');
        }

    }

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    }

    const handleOkButtonModelPopup = () => {
        navigate('/');
        setmodelPopupshow(false);
    }

    const handleChangeConfirmCheckbox = () => {
        setIsConfirmChecked(!isConfirmChecked);
    }
    const validateInitiatorEmail = (e) => {
        const email = e.target.value;
        if (validator.isEmail(email)) {
            setInitiatorEmailAddress(e.target.value);
            setInitiatorEmailError("");
        } else {
            setInitiatorEmailAddress(e.target.value);
            setInitiatorEmailError("Please enter valid email id.");
        }
    }
    const validateVendorEmail = (e) => {
        const vEmail = e.target.value;
        if (validator.isEmail(vEmail)) {
            setVendorEmail(e.target.value)
            setVendorEmailError("");
        } else {
            setVendorEmail(e.target.value)
            setVendorEmailError("Please enter valid email id");
        }
    }


    if (auth && auth.userData) {
        return (

            <form onSubmit={handleSubmit}>
                <div class="container">
                    <div class="row">
                        <div class="col-8 p-0">
                            <img src={imgLogo} alt="Logo" width="100%" height="80%" />
                        </div>
                        <div class="col-4 p-0">
                            <img src={rightLogo} alt="Logo" width="100%" height="80%" />
                        </div>
                    </div>
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Vendor Information</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row"><label style={{ color: 'red' }}>{apiErrormessage}</label> </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="InitiatorEmailAddress">Initiator User ID<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={InitiatorEmailAddress}
                                    onChange={(e) => setInitiatorEmailAddress(e.target.value)}
                                    placeholder="Enter Initiator User ID" required />
                            </div>
                            <div class="col-2">
                                <label for="DPMSTickerNumber">DPMS Ticket ID<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="number"
                                    value={DPMSTicketNumber}
                                    onChange={(e) => setDPMSTicketNumber(e.target.value)}
                                    placeholder="XXXXXX" required style={{ borderColor: invalidTicketID ? 'red' : '' }} />
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="vendorCode">Vendor Code<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="number"
                                    value={VendorCode}
                                    onChange={(e) => setVendorCode(e.target.value)}
                                    placeholder="Enter Vendor Code" required style={{ borderColor: invalidVendorCode ? 'red' : '' }} />
                            </div>
                            <div class="col-2">
                                <label for="vendorName">Vendor Name<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={VendorName}
                                    onChange={(e) => setVendorName(e.target.value)}
                                    placeholder="Enter Vendor Name" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="vendorEmail">Vendor Email<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={VendorEmail}
                                    onChange={(e) => validateVendorEmail(e)}
                                    placeholder="Enter Vendor email" required />
                                <div style={{ color: 'red' }}>{vendorEmailError}</div>
                            </div>
                            <div class="col-2">
                                <label for="Date">Date</label>
                            </div>
                            <div class="col-4">
                                <input type="Date"
                                    value={DateValue}
                                    onChange={(e) => setDateValue(e.target.value)}
                                    placeholder="Enter Date" required readOnly style={{ backgroundColor: '#e9ecefe3' }} />
                            </div>
                        </div>

                       
                        <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Supplier Comments</h5></div></div>
                        <div class="row">
                            {/* <div class="col-2">
                                <label for="SupplierComments1">Supplier Comments</label>
                            </div> */}
                            <div class="col-12">
                                <textarea class="VendorComments" id="Comments" name="Comments" value={SupplierComments1} placeholder="Enter Supplier Comments" onChange={(e) => setSupplierComments1(e.target.value)} ></textarea>
                            </div>
                        </div>
                        <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Attachments <label style={{ color: 'red' }}>*</label></h5></div></div>
                        <div class="row">
                            {/* <div class="col-2">
                                <label for="subject">Attachments</label>
                            </div> */}
                            <div class="col-10">
                                <input type="file" onChange={(e) => setSelectedFile(e.target.files ? e.target.files : null)} required multiple />
                            </div>
                        </div>
                    </div>
                    <br/>


                    <div class="row">
                        <div>
                            <input type="checkbox" value={isConfirmChecked} style={{ color: 'red' }} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label style={{ color: 'red' }}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <input type="submit" value="Submit" /> &nbsp;
                            <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
                            <input type="button" value="Cancel" onClick={onClickCancelHandler} />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-10 text-success">
                            <Modal
                                show={modelPopupshow}
                                onHide={handleOkButtonModelPopup}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                                    <Modal.Title> Pending Mark/Draft Update Request</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p> Your Pending Mark/Draft update request has been submitted.</p>
                                    <p> You will receive an email with the request information and details for tracking purposes.</p>
                                    <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
                                    <p> Click <strong><mark>OK</mark></strong> to return to the home page.</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleOkButtonModelPopup}>
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal
                                show={loading}
                                onHide={handleOkButtonModelPopup}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                                    <Modal.Title>Request in-progress, please wait...</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Loading....</p>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </div>
            </form>
        )
    } else {
        return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
    }
}

export default PictureMarkingApprovalRequest;
